<app-fixed-editor *ngIf="_element.editorId && fixedEditor && !isSubmitted" [element]="fixedEditor"></app-fixed-editor>

<div *ngIf="!isSubmitted && !immediateFeedBackRequired" [attr.id]="'destination'+index"
  class="new-question new-question-top-align mx-auto" [class.fullheight-scroll-container]="!isSubmitted">
  <div class="new-question__container next-button-spacing">
    <div class="new-question--titleBox">
      <div [froalaView]="_element?.question" class="mg-b10 font-16 lh-30 font-mob-14 lh-mob-24"></div>
      <div *ngIf="_element?.description" class="new-question--hint">
        {{_element?.description}}
      </div>
    </div>
    <div class="rating-accordion" *ngIf="!radioSelected">
      <div (click)="section['first'] = !section['first']">
        <p class="rating-accordion__title">CHOOSE <span>THE</span> BEST <span>APPROACH</span></p>
      </div>
      <div class="new-options" *ngIf="!section['first']">
        <div class="rating-select2 rating-select2--full">
          <label *ngFor="let opt of _element.options" class="rating-select2__option">
            <span class="rating-select2__radiotext">
              <input class="rating-select2__radio" [value]="opt._id" type="radio" [(ngModel)]="radioSelected"
                name="mostLikely" (change)="getText(opt.text);">
              <span class="rating-select2__icon-radio"></span>
              <span class="rating-select2__title">{{opt.text}}</span>
            </span>
          </label>
        </div>
      </div>
    </div>
    <div class="rating-accordion"  *ngIf="radioSelected">
    <div class="new-options">
      <div class="rating-select2 rating-select2--full">
        <h3 class="rating-selected__title">Your Best Approach</h3>
        <label class="rating-select2__option">
          <span class="rating-select2__radiotext">
            <span class="rating-select2__title">{{selectedText}}</span>
          </span>
        </label>
      </div>
      <div class="text-right mg-b20">
        <button class="p-0 btn-link btn" (click)="radioSelected=null">Change</button>
      </div>
  </div>
</div>
    <div class="rating-accordion" *ngIf="!radioSelectedLeast">
      <div (click)="section['second'] = !section['second']">
        <p class="rating-accordion__title">CHOOSE <span>THE</span> WORST <span>APPROACH</span></p>
      </div>
      <div class="new-options" *ngIf="section['second']">
        <div class="rating-select2 rating-select2--full">
          <label *ngFor="let opt of _element.optionsLeast" class="rating-select2__option">
            <span class="rating-select2__radiotext">
              <input class="rating-select2__radio" [value]="opt._id" type="radio" [(ngModel)]="radioSelectedLeast" (change)="getSecondText(opt.text);"
              name="leastLikely">
              <span class="rating-select2__icon-radio"></span>
              <span class="rating-select2__title">{{opt.text}}</span>
            </span>
          </label>
        </div>
      </div>
    </div>
    <div class="rating-accordion" *ngIf="radioSelectedLeast">
    <div class="new-options">
      <div class="rating-select2 rating-select2--full">
        <h3 class="rating-selected__title">Your Worst Approach</h3>
        <label class="rating-select2__option">
          <span class="rating-select2__radiotext">
            <span class="rating-select2__title">{{secondSelectedText}}</span>
          </span>
        </label>
      </div>
      <div class="text-right mg-b20">
        <button class="p-0 btn-link btn" (click)="radioSelectedLeast=null">Change</button>
      </div>
    </div>
  </div>

    <app-exercise-navigation-bar *ngIf="radioSelected && radioSelectedLeast" [id]="id" [id]="id" [questionAttempted]="radioSelected" [questionAttemptedLeast]="radioSelectedLeast" (onNext)="next(radioSelected, radioSelectedLeast)"
      (onSubmit)="next(radioSelected,radioSelectedLeast, true)"
      [exerciseTimetrackingdata] ="exerciseTimetrackingdata"
      [index]='index'
      >
    </app-exercise-navigation-bar>
  </div>
</div>

<div *ngIf="!isSubmitted && immediateFeedBackRequired" [attr.id]="'destination'+index"
  class="new-question new-question-top-align mx-auto" [class.fullheight-scroll-container]="!isSubmitted">
  <div class="new-question__container next-button-spacing">
    <div class="new-question--titleBox">
      <div [froalaView]="_element?.question" class="mg-b10 font-16 lh-30 font-mob-14 lh-mob-24"></div>
    </div>
    <div class="rating-accordion" *ngIf="!radioSelected">
      <div (click)="section['first'] = !section['first']">
        <p class="rating-accordion__title">CHOOSE <span>THE</span> BEST <span>APPROACH</span></p>
      </div>
      <div class="new-options" *ngIf="!section['first']">
        <div class="rating-select2 rating-select2--full">
          <label *ngFor="let opt of _element.options" class="rating-select2__option">
            <span class="rating-select2__radiotext">
              <input class="rating-select2__radio" [value]="opt._id" type="radio" [(ngModel)]="radioSelected"
                name="mostLikely" (change)="getText(opt.text);">
              <span class="rating-select2__icon-radio"></span>
              <span class="rating-select2__title">{{opt.text}}</span>
            </span>
          </label>
        </div>
      </div>
    </div>
    <div class="rating-accordion"  *ngIf="radioSelected">
      <div class="new-options">
        <div class="rating-select2 rating-select2--full">
          <label class="rating-select2__option">
            <span class="rating-select2__radiotext">
              <span class="rating-select2__title">Your Best Approach</span>
            </span>
          </label>
          <label class="rating-select2__option">
            <span class="rating-select2__radiotext">
              <span class="rating-select2__title">{{selectedText}}</span>
            </span>
          </label>
        </div>
        <div class="text-right mg-b20">
          <button class="p-0 btn-link btn" (click)="radioSelected=null">Change</button>
        </div>
    </div>
  </div>
    <div class="rating-accordion" *ngIf="!radioSelectedLeast">
      <div (click)="section['second'] = !section['second']">
        <p class="rating-accordion__title">CHOOSE <span>THE</span> WORST <span>APPROACH</span></p>
      </div>
      <div class="new-options" *ngIf="section['second']">
        <div class="rating-select2 rating-select2--full">
          <label *ngFor="let opt of _element.optionsLeast" class="rating-select2__option">
            <span class="rating-select2__radiotext">
              <input class="rating-select2__radio" [value]="opt._id" type="radio" [(ngModel)]="radioSelectedLeast"
              name="leastLikely" (change)="getSecondText(opt.text);">
              <span class="rating-select2__icon-radio"></span>
              <span class="rating-select2__title">{{opt.text}}</span>
            </span>
          </label>
        </div>
      </div>
    </div>
    <div class="rating-accordion" *ngIf="radioSelectedLeast">
      <div class="new-options">
        <div class="rating-select2 rating-select2--full">
          <label class="rating-select2__option">
            <span class="rating-select2__radiotext">
              <span class="rating-select2__title">Your Worst Approach</span>
            </span>
          </label>
          <label class="rating-select2__option">
            <span class="rating-select2__radiotext">
              <span class="rating-select2__title">{{secondSelectedText}}</span>
            </span>
          </label>
        </div>
        <div class="text-right mg-b20">
          <button class="p-0 btn-link btn" (click)="radioSelectedLeast=null">Change</button>
        </div>
      </div>
    </div>
    <div *ngIf="radioSelected && questionChecked &&  _element?.isFeedbackEnabled" class="overall-feedback pb-0">
      <p [froalaView]="_element.feedback" class="overall-feedback__desc"></p>
    </div>

    <app-exercise-navigation-bar *ngIf="radioSelected && radioSelectedLeast" [id]="id" [immediateFeedBackRequired]="true" [questionAttempted]="radioSelected" [questionAttemptedLeast]="radioSelectedLeast" (onReview)="check()" (onNext)="next(radioSelected, radioSelectedLeast)"
    (onSubmit)="next(radioSelected,radioSelectedLeast, true)" [questionChecked]="questionChecked"
    [exerciseTimetrackingdata] ="exerciseTimetrackingdata"
    [index]='index'
    >
  </app-exercise-navigation-bar>
  </div>
</div>

<div *ngIf="isSubmitted" [attr.id]="'destination'+index" [class.new-options--not-answered]="!_answer"
  class="new-question new-question-top-align mx-auto" [class.fullheight-scroll-container]="!isSubmitted">
  <div class="new-question__container">
    <div class="new-question--titleBox"
      [class.score-applied]="_element?.isScoring &&  _answer && points  && isResultPublished">
      <div [froalaView]="_element?.question" class="mg-b10 font-16 lh-30 font-mob-14 lh-mob-24"></div>
      <!-- <span *ngIf="!isPractice && _element?.isScoring &&  _answer && points  && isResultPublished && !isTouchstone"
        class="answer-point">Points:
        {{(points?points.point:0 ) | number:'1.0-2'}} out of
        {{(points?points.total:0 ) | number:'1.0-2'}}</span> -->
    </div>
    <div class="rating-accordion">
      <p class="rating-accordion__title">CHOOSE <span>THE</span> BEST <span>APPROACH</span></p>
      <div class="new-options">
        <div class="rating-select2 py-2 rating-select2--full">
          <label *ngFor="let opt of _element.options" class="rating-select2__option">
            <span class="rating-select2__radiotext">
              <input class="rating-select2__radio" [value]="opt._id" type="radio" disabled [(ngModel)]="radioSelected"
                name="mostLikely">
              <span class="rating-select2__icon-radio"></span>
              <span class="rating-select2__title">{{opt.text}}</span>
            </span>
          </label>
        </div>
      </div>
    </div>
    <div class="rating-accordion">
      <p class="rating-accordion__title">CHOOSE <span>THE</span> WORST <span>APPROACH</span></p>
      <div class="new-options">
        <div class="rating-select2 py-2 rating-select2--full">
          <label *ngFor="let opt of _element.optionsLeast" class="rating-select2__option">
            <span class="rating-select2__radiotext">
              <input class="rating-select2__radio" [value]="opt._id" type="radio" disabled [(ngModel)]="radioSelectedLeast"
              name="leastLikely">
              <span class="rating-select2__icon-radio"></span>
              <span class="rating-select2__title">{{opt.text}}</span>
            </span>
          </label>
        </div>
      </div>
    </div>
     <!-- thrive -->
     <ng-container *ngIf="questionBlos && questionBlos.length">     
      <h5 class="question__thrive">Thrive Skills:</h5>
      <div class="question__thrive-list">
        <ul>
          <ng-container *ngFor="let blo of questionBlos">
            <li [innerHTML]="blo.shortStatement"></li>
          </ng-container>
        </ul>
      </div>
    </ng-container>
    <div *ngIf="_element?.isFeedbackEnabled" class="overall-feedback">
      <p class=" montserrat-medium terneryColor font-14 font-mob-12 mg-b15 pd-xs-t30" *ngIf="variableFeedback">{{variableFeedback}}</p>
      <p [froalaView]="_element.feedback" class="overall-feedback__desc"></p>
    </div>
  </div>
  <!-- <app-like-dislike [id]="id" *ngIf="_element?.isFeedbackEnabled" [userFeedback]="userFeedback" [_element]="_element"
    (reportFeedback)="_reportFeedback($event)" (likeDislike)="_likeDislike($event)">
  </app-like-dislike> -->
</div>
